module.exports = __webpack_public_path__ + "static/img/head-pt.1e2b4e49.webp";